import { Asset } from '~modules/media-library/model/Asset';

const DPI_FACTOR = 2.539999999997257;
const FORMAT_OFFSET_DPI = 300;
const FORMAT_NEWSPAPER_DPI = 200;
const FORMAT_MEDIA_DPI = 50;

function round2Decimals(num: number) {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}

export function DimensionTable({ asset }: { asset: Asset }) {
  const width = asset?.attributes?.width;
  const height = asset?.attributes?.height;

  // Early exit
  if (!width || !height) return null;

  // Calculate values
  const offsetWidth = (width / FORMAT_OFFSET_DPI) * DPI_FACTOR;
  const offsetHeight = (height / FORMAT_OFFSET_DPI) * DPI_FACTOR;
  const newspaperWidth = (width / FORMAT_NEWSPAPER_DPI) * DPI_FACTOR;
  const newspaperHeight = (height / FORMAT_NEWSPAPER_DPI) * DPI_FACTOR;
  const mediaWidth = (width / FORMAT_MEDIA_DPI) * DPI_FACTOR;
  const mediaHeight = (height / FORMAT_MEDIA_DPI) * DPI_FACTOR;

  return (
    <div className="font-sans text-sm text-black">
      <div className="font-sans font-bold pt-4 pb-2">Recommended dimensions based on masterfile</div>
      <table className="w-full">
        <thead className="text-darkgray">
          <tr className="border-gray border-solid border-b">
            <th>&nbsp;</th>
            <th align="left">Max. width</th>
            <th align="left">Max. height</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-gray border-solid border-b">
            <th className="text-darkgray py-2" align="left">
              Standard offset ({FORMAT_OFFSET_DPI}dpi)
            </th>
            <td>{round2Decimals(offsetWidth)} cm</td>
            <td>{round2Decimals(offsetHeight)} cm</td>
          </tr>
          <tr className="border-gray border-solid border-b">
            <th className="text-darkgray py-2" align="left">
              Newspaper ({FORMAT_NEWSPAPER_DPI}dpi)
            </th>
            <td>{round2Decimals(newspaperWidth)} cm</td>
            <td>{round2Decimals(newspaperHeight)} cm</td>
          </tr>
          <tr className="border-gray border-solid border-b">
            <th className="text-darkgray py-2" align="left">
              Large-scale media ({FORMAT_MEDIA_DPI}dpi)
            </th>
            <td>{round2Decimals(mediaWidth)} cm</td>
            <td>{round2Decimals(mediaHeight)} cm</td>
          </tr>
        </tbody>
      </table>
      <div className="py-4">
        <div className="font-bold">Advice</div>
        <div className="text-red">The screen and office views are not appropriate for printing.</div>
      </div>
    </div>
  );
}
